/**
 * Cee-lo state map factory. All states migrated to v2.
 *
 * Active flow:
 *   WAITING → STARTING → HI_LO → BANKER_SET_POT → FADING →
 *   PLAYER_BETTING → BANKER_ROLL → (instant win/loss) ROUND_END
 *                                ↓ (point established)
 *   PLAYER_BETTING → PLAYER_ROLL → (next shooter or ROUND_END)
 *                                ↓
 *   ROUND_END → STARTING (next round) → ...
 */

import { CeeloState } from '@sdl/shared';
import type { State } from '../State.js';
import type { StateMachine } from '../StateMachine.js';
import type { SDLGame } from '../SDLGame.js';
import { WaitingState } from '../states/WaitingState.js';
import { StartingState } from '../states/StartingState.js';
import { RoundEndState } from '../states/RoundEndState.js';
import { BankerSetPotState } from '../states/BankerSetPotState.js';
import { FadingState } from '../states/FadingState.js';
import { PlayerBettingState } from '../states/PlayerBettingState.js';
import { BankerRollState } from '../states/BankerRollState.js';
import { PlayerRollState } from '../states/PlayerRollState.js';
import { HiLoState } from '../states/HiLoState.js';
import { GameEndState } from '../states/GameEndState.js';

export function buildCeeloStates(
  sm: StateMachine,
  game: SDLGame,
): Map<string, State> {
  const states = new Map<string, State>();
  states.set(CeeloState.WAITING, new WaitingState(sm, game));
  states.set(CeeloState.STARTING, new StartingState(sm, game));
  states.set(CeeloState.HI_LO, new HiLoState(sm, game));
  states.set(CeeloState.BANKER_SET_POT, new BankerSetPotState(sm, game));
  states.set(CeeloState.FADING, new FadingState(sm, game));
  states.set(CeeloState.PLAYER_BETTING, new PlayerBettingState(sm, game));
  states.set(CeeloState.BANKER_ROLL, new BankerRollState(sm, game));
  states.set(CeeloState.PLAYER_ROLL, new PlayerRollState(sm, game));
  states.set(CeeloState.ROUND_END, new RoundEndState(sm, game));
  states.set(CeeloState.GAME_END, new GameEndState(sm, game));
  return states;
}
